import { Avatar } from '@e2n/ui/v2';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';
import { useAbteilungsleiter } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useAbteilungsleiter/useAbteilungsleiter';
import { MultiSelectV2 } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/MultiSelectV2';

export function AbteilungsleiterMultiSelect({
  values,
  handleChange,
  arbeitsbereichId,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  arbeitsbereichId?: string | undefined;
}) {
  const { t } = useTranslation();
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const { abteilungsleiter } = useAbteilungsleiter(
    standortIds,
    arbeitsbereichId,
  );

  const options = abteilungsleiter.map((abteilungsleiter) => ({
    value: abteilungsleiter.id,
    label: `${abteilungsleiter.vorname} ${abteilungsleiter.nachname}`,
    avatar: (
      <Avatar
        size="xs"
        type="initials"
        initials={`${abteilungsleiter.vorname.charAt(0).toUpperCase()}${abteilungsleiter.nachname.charAt(0).toUpperCase()}`}
      />
    ),
  }));

  return (
    <MultiSelectV2
      options={options}
      values={values}
      onChange={handleChange}
      title={t(
        'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.label',
      )}
    />
  );
}
